import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Menu, MenuItem, ListItemIcon, Divider } from '@mui/material';
import {
  Settings as SettingsIcon,
  Person as PersonIcon,
  Logout as LogoutIcon,
  Upgrade as UpgradeIcon,
  EditNote as EditNoteIcon
} from '@mui/icons-material';

const UserMenu = ({ onLogout, onOpenSettings, onOpenDefaultPrompt }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action) => {
    handleClose();
    if (action === 'logout') onLogout();
    if (action === 'settings') onOpenSettings();
    if (action === 'profile') navigate('/profile');
    if (action === 'upgrade') navigate('/upgrade');
    if (action === 'defaultPrompt') onOpenDefaultPrompt();
  };

  // No additional actions here

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2, backgroundColor: 'transparent' }}
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <SettingsIcon sx={{ width: 20, height: 20, color: 'inherit' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="user-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '& .MuiMenuItem-root': { fontSize: '0.875rem', minHeight: 30, py: 0.5 },
            '& .MuiListItemIcon-root': { minWidth: 32 }
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        MenuListProps={{ dense: true }}
      >

        <MenuItem onClick={() => handleMenuItemClick('profile')}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('defaultPrompt')}>
          <ListItemIcon>
            <EditNoteIcon fontSize="small" />
          </ListItemIcon>
          View/Edit Default System Prompt
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('upgrade')}>
          <ListItemIcon>
            <UpgradeIcon fontSize="small" />
          </ListItemIcon>
          Upgrade
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleMenuItemClick('logout')}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>

    </>
  );
};

export default UserMenu;
